import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './VenueDetail.css';

function House() {
  const [space, setSpace] = useState(null);

  useEffect(() => {
    client
      .fetch('*[_type == "venue"][0]{ spaces[slug == "house"][0] }')
      .then(data => {
        if (data && data.spaces) setSpace(data.spaces);
      });
  }, []);

  const images = (space && space.images) || [];
  const validImages = images.filter(img => img && img.asset);

  return (
    <div className="venue-detail-page">
      <SEO
        title="2F 하우스 | House"
        description="가든포에트 2F 하우스 - 유럽풍 인테리어의 프라이빗 하우스. 소규모 웨딩, 홈파티, 특별한 모임."
        path="/venue/house"
      />
      <section className="detail-hero">
        <div className="container">
          <div className="detail-hero-content fade-in">
            <h1>2층 테라스 하우스</h1>
            <p className="capacity-tag">수용 인원: 50-60명</p>
          </div>
        </div>
      </section>

      <section className="detail-description">
        <div className="container">
          <div className="space-notice fade-in">
            <span className="notice-tag">📷 시즌 프리뷰</span>
          </div>
          <div className="description-content fade-in">
            <p>
              2층 테라스 하우스는<br />
              프렌치 빈티지 감성이 담긴 유럽 하우스입니다.<br />
              자연채광이 가득 들어오는 창 너머로<br />
              자작나무 잎사귀가 바람에 흔들립니다.
            </p>
            <p>
              편안한 식사 공간이자,<br />
              신부가 준비하는 특별한 시간을 보내는 곳입니다.<br />
              메이크업과 피팅을 위한 공간, 단독 화장실,<br />
              그리고 루프탑까지 갖춘 이곳에서<br />
              결혼식 전 소중한 순간들이 펼쳐집니다.
            </p>
            <p>
              2층 테라스에 서면 정원 전체가 내려다보입니다.<br />
              자작나무 숲 사이로 사람들이 모이고,<br />
              예식이 준비되는 모습을 바라보며<br />
              마음을 가다듬습니다.
            </p>
            <p>
              햇살이 창을 통해 들어오고,<br />
              바람이 커튼을 흔들고,<br />
              시간이 천천히 흐릅니다.<br />
              신부는 거울 앞에 앉아 메이크업을 받고,<br />
              어머니는 옆에서 딸의 드레스를<br />
              정성스럽게 펼칩니다.
            </p>
            <p>
              50-60명까지 수용 가능하며,<br />
              가까운 가족들이 이곳에서<br />
              편안하게 식사를 나눌 수 있습니다.<br />
              야외 테라스에서는 신선한 공기를 마시며<br />
              잠시 쉬어갈 수도 있습니다.
            </p>
            <p className="closing">
              루프탑에 올라서면 또 다른 풍경이 펼쳐집니다.<br />
              홍대의 골목들과 하늘,<br />
              그리고 발 아래 펼쳐진 작은 숲.<br />
              특별한 날의 특별한 순간을 위한 공간입니다.
            </p>
          </div>
        </div>
      </section>

      {validImages.length > 0 && (
        <section className="detail-gallery">
          <div className="container-wide">
            <div className="gallery-grid fade-in">
              {validImages.map(function(image, i) {
                return (
                  <div key={i} className="gallery-item">
                    <img 
                      src={urlFor(image).width(800).url()} 
                      alt={`2층 테라스 하우스 ${i + 1}`}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default House;
